import React from 'react';
import PropTypes from 'prop-types';

import './styles/attachment_card.scss';

// Note: ./simple_asset_card is a rip-off of this component and also relies on the styles
// so that assets can be rendered to look like attachments
const AttachmentCard = ({ assetKey, assetName, attachment, brandfolderSlug } = this.props) => {
  const assetLink = `${window.location.href.split('attachments')[0].split('/#!asset')[0]}/#!asset/${assetKey}`;
  return (
    <li className="attachment-card-component">
      <a href={assetLink} target="_blank" rel="noopener noreferrer">
        <div className="card-head">
          <div className="card-head__thumbnail">
            <img src={attachment.thumbnail_url} alt="thumbnail" />
          </div>
        </div>
        <div className="card-description">
          <p className="attachment-name">{attachment.filename}</p>
          <div className="file-type-pill">
            <span>{attachment.extension}</span>
          </div>
        </div>
      </a>
    </li>
  );
};

AttachmentCard.propTypes = {
  asset: PropTypes.object,
  assetKey: PropTypes.string.isRequired,
  attachment: PropTypes.object,
  assetName: PropTypes.string,
  brandfolderSlug: PropTypes.string
};

export default AttachmentCard;
